import React, { useState } from "react";

import {
    StyledEmptyFolder,
    StyledEmptyFolderContainer,
    StyledGenerateTachContainer,
    StyledTitleEmptyFolder,
} from "../../../styles/pages/AdministratorTach/AdministratorTachStyles";
import ButtonStyles from "../../../styles/components/ButtonStyles";
import { StyledAlertBox } from "../../../styles/pages/AcademicActivityPlanStyles";
import { Alert } from "../../../components/Icons";
import EmptyFolder from "../../../assets/images/empty-folder.png";

import { useAdministratorTach } from "../../../context/AdministratorTachContext";
import { StyledSubTitle } from "../../../styles/MainStyles";
import ModalGenerateTach from "../Modal/Actions/ModalGenerateTach";
import { useFilterData } from "../../../context/TachContext/FilterDataContext";

const { BtnPrimary } = ButtonStyles;

const GenerateTach = () => {
    const { isCreatedSubprocess, isPendingProcess } = useAdministratorTach();
    const { handleResetFilter } = useFilterData();
    const [openModal, setOpenModal] = useState<boolean>(false);

    const border = !isCreatedSubprocess ? "borderTopEmptyFolder" : "";

    const handleOpenModal = () => {
        handleResetFilter(false);
        setOpenModal(true);
    };

    return (
        <div>
            <StyledGenerateTachContainer className={border}>
                {!isCreatedSubprocess && (
                    <StyledEmptyFolderContainer>
                        <StyledEmptyFolder
                            src={EmptyFolder}
                            alt="Imagem de um arquivo vazio."
                        />
                        <StyledTitleEmptyFolder>
                            Ainda não há TACHs geradas
                        </StyledTitleEmptyFolder>
                        <StyledSubTitle style={{ marginBottom: 40 }}>
                            Você pode começar pelo botão abaixo
                        </StyledSubTitle>
                    </StyledEmptyFolderContainer>
                )}
                {isPendingProcess && (
                    <StyledAlertBox style={{ marginRight: 24 }}>
                        <Alert style={{ fill: "#E1E1E1" }} />
                        Por favor, aguarde. Estamos processando o TACH.
                    </StyledAlertBox>
                )}
                <BtnPrimary
                    style={{
                        width: 126,
                        height: 48,
                    }}
                    onClick={() => handleOpenModal()}
                    disabled={isPendingProcess}
                >
                    Gerar TACH
                </BtnPrimary>
            </StyledGenerateTachContainer>
            {openModal && (
                <ModalGenerateTach
                    isOpen={openModal}
                    onHide={() => setOpenModal(false)}
                />
            )}
        </div>
    );
};

export default GenerateTach;
